import React, { useState } from 'react';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ModuleCard from '../../../appointment/components/moduleCard/ModuleCard';
import FinancialOverview from './components/overview/FinancialOverview';
import FinancialSection from './components/section/FinancialSection';
import { PaymentsFilter, PaymentsList, usePaymentsFilter } from './components/payments/PaymentsList';
import WalletSection from './components/wallet-section/WalletSection';
import WalletPurchaseButton from './components/wallet-section/WalletPurchaseButton';
import usePatientWallet from './components/wallet-section/usePatientWallet';
import styles from './Financial.module.css';

/**
 * Seção Financeiro da ficha. Três degraus de leitura:
 *   1. resumo (a receber, recebido, sessões, vencimento, saldo);
 *   2. pacotes: cartões por pacote, movimentações e a venda;
 *   3. atendimentos: em aberto e pagos, cada linha abre o atendimento.
 *
 * `data` vem de get_patient.php (`financial`): `torecive`, `paid` e `stats`.
 */
const Financial = ({ patientData, data }) => {
  const open = data?.torecive || [];
  const paid = data?.paid || [];
  const wallet = usePatientWallet(patientData.id);
  const payments = usePaymentsFilter(open, paid);
  const [purchaseOpen, setPurchaseOpen] = useState(false);

  return (
    <ModuleCard
      title="Financeiro"
      icon={<AccountBalanceWalletOutlinedIcon />}
      description="Pagamentos, pacotes e sessões"
      accent="green"
    >
      <div className={styles.area}>
        <FinancialOverview open={open} paid={paid} stats={data?.stats} wallet={wallet} />

        <FinancialSection
          title="Pacotes"
          hint="Sessões compradas, uso por procedimento e validade"
          actions={<WalletPurchaseButton onClick={() => setPurchaseOpen(true)} />}
        >
          <WalletSection
            wallet={wallet.wallet}
            packages={wallet.packages}
            transactions={wallet.transactions}
            loading={wallet.loading}
            onRefresh={wallet.refresh}
            purchaseOpen={purchaseOpen}
            onPurchaseOpenChange={setPurchaseOpen}
          />
        </FinancialSection>

        <FinancialSection
          title="Atendimentos"
          hint="Clique em um atendimento para faturar ou ver o pagamento"
          actions={<PaymentsFilter value={payments.filter} onChange={payments.setFilter} counts={payments.counts} />}
        >
          <PaymentsList filter={payments.filter} items={payments.items} />
        </FinancialSection>
      </div>
    </ModuleCard>
  );
};

export default Financial;
